/* eslint-disable no-unused-vars */
export enum ETypeNotification {
  DEFAULT,
  SUCCESS,
  WARNING,
  DANGER,
  INFO,
}

export interface INotification {
  id?: string;
  type?: ETypeNotification;
  title: string;
  message: string;
  errorCode?: string;
  url?: string;
  icon?: string;
  duration?: number;
  viewed?: boolean;
}

export interface IConfigNotification {
  duration?: number;
  title?: string;
  message?: string;
  type?: string;
  icon?: string;
}
